/**
 * Контент довідки для сторінки заявок (Requests).
 * Використовується в панелі довідки HelpPanel.
 */
export default {
  pageKey: 'requests',
  titleKey: 'help.pages.requests.title',
  overviewKey: 'help.pages.requests.overview',
  tourId: 'requests-page',

  faq: [
    {
      id: 'create-request',
      questionKey: 'help.pages.requests.faq.createRequest.question',
      answerKey: 'help.pages.requests.faq.createRequest.answer',
    },
    {
      id: 'request-statuses',
      questionKey: 'help.pages.requests.faq.statuses.question',
      answerKey: 'help.pages.requests.faq.statuses.answer',
    },
    {
      id: 'cancel-request',
      questionKey: 'help.pages.requests.faq.cancel.question',
      answerKey: 'help.pages.requests.faq.cancel.answer',
    },
    {
      id: 'support-chat',
      questionKey: 'help.pages.requests.faq.supportChat.question',
      answerKey: 'help.pages.requests.faq.supportChat.answer',
    },
    {
      id: 'response-time',
      questionKey: 'help.pages.requests.faq.responseTime.question',
      answerKey: 'help.pages.requests.faq.responseTime.answer',
    },
  ],

  tooltips: {
    newRequest: 'help.tooltips.requests.newRequest',
    statusFilter: 'help.tooltips.requests.statusFilter',
    supportSection: 'help.tooltips.requests.supportSection',
  },

  relatedTours: ['billing-page', 'devices-page'],
}
